{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "已預約",
      "confirmed": "已確認",
      "completed": "已完成",
      "cancelled": "已取消",
      "no-show": "未到診",
      "checked-in": "已報到"
    },
    "resultStatus": {
      "final": "最終",
      "preliminary": "初步",
      "corrected": "已更正"
    },
    "allergySeverity": {
      "severe": "嚴重",
      "high": "高",
      "moderate": "中度"
    },
    "nationalIdType": {
      "NRIC": "NRIC（新加坡身分證）",
      "HKID": "HKID（香港身份證）",
      "MyKad": "MyKad（馬來西亞身分證）",
      "Aadhaar": "Aadhaar（印度身分證）",
      "KTP": "KTP（印尼身分證）",
      "Passport": "護照"
    },
    "messageSenderType": {
      "provider": "醫護人員",
      "patient": "病人"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "兩次輸入的密碼不一致",
      "passwordMinLength": "密碼至少需要 8 個字元"
    }
  },
  "labels": {
    "abnormal": "異常"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "我的健康",
        "results": "檢驗結果",
        "appointments": "預約",
        "messages": "訊息",
        "forms": "表格"
      },
      "signOut": "登出",
      "signOutAria": "登出",
      "navAria": "門戶導覽",
      "footer": "VynaEMR 病人門戶 — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "病人門戶",
      "labels": {
        "email": "電郵",
        "password": "密碼"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "請輸入密碼"
      },
      "button": {
        "signIn": "登入",
        "signingIn": "登入中..."
      },
      "toast": {
        "welcome": "歡迎回來！",
        "invalid": "電郵或密碼無效"
      },
      "links": {
        "noAccount": "沒有帳戶？",
        "register": "註冊"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "早晨",
        "afternoon": "下午好",
        "evening": "晚安",
        "fallbackName": "您"
      },
      "subtitle": "以下是您的健康摘要。",
      "error": "無法載入您的健康摘要，請稍後再試。",
      "demographics": {
        "ageLabel": "{{age}} 歲",
        "bloodTypeLabel": "血型：{{bloodType}}"
      },
      "quickLinks": {
        "results": "檢驗結果",
        "appointments": "預約",
        "messages": "訊息",
        "forms": "表格"
      },
      "sections": {
        "allergies": "過敏",
        "activeMedications": "現時用藥",
        "activeProblems": "現時健康問題",
        "upcomingAppointments": "即將到來的預約",
        "recentResults": "最近結果",
        "immunizations": "疫苗接種記錄",
        "emergencyContact": "緊急聯絡人"
      },
      "states": {
        "noAllergies": "沒有已記錄的過敏。",
        "noMedications": "沒有現時用藥。",
        "noAppointments": "沒有即將到來的預約。",
        "noResults": "沒有最近結果。"
      },
      "moreCount": "另有 {{count}} 項",
      "sinceDate": "自 {{date}} 起",
      "doseNumber": "第 {{number}} 劑",
      "viewAll": "查看全部",
      "providerTBD": "醫生待定"
    },
    "register": {
      "subtitle": "建立您的帳戶",
      "labels": {
        "fullName": "姓名",
        "email": "電郵",
        "dateOfBirth": "出生日期",
        "phone": "電話",
        "mrn": "MRN（病歷編號）",
        "idType": "證件類型",
        "idNumber": "證件號碼",
        "password": "密碼",
        "confirmPassword": "確認密碼"
      },
      "placeholders": {
        "fullName": "請輸入您的姓名",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "請輸入您的證件號碼",
        "password": "至少 8 個字元",
        "confirmPassword": "請再次輸入密碼",
        "selectIdType": "請選擇..."
      },
      "mrnHint": "如要將帳戶連結至您的病歷，請提供 MRN 或身份證號碼。",
      "button": {
        "createAccount": "建立帳戶",
        "creatingAccount": "建立帳戶中..."
      },
      "toast": {
        "success": "註冊成功，請登入。",
        "failure": "註冊失敗，請再試一次。"
      },
      "links": {
        "haveAccount": "已有帳戶？",
        "signIn": "登入"
      },
      "aria": {
        "dateOfBirth": "出生日期"
      }
    },
    "appointments": {
      "title": "預約",
      "subtitle": "查看及管理您的預約",
      "error": "無法載入預約，請稍後再試。",
      "sections": {
        "upcoming": "即將到來",
        "past": "過往"
      },
      "states": {
        "noUpcoming": "暫無即將到來的預約。",
        "noPast": "暫無過往預約。"
      },
      "reasonLabel": "原因：{{reason}}",
      "instructionsLabel": "注意事項：{{instructions}}",
      "durationMinutes": "{{minutes}} 分鐘",
      "actions": {
        "cancel": "取消",
        "confirmCancel": "確認",
        "cancelling": "正在取消...",
        "keep": "保留"
      },
      "toast": {
        "cancelSubmitted": "已提交取消申請，您的醫療團隊會與您確認。",
        "cancelFailed": "取消預約失敗，請致電診所。"
      }
    },
    "results": {
      "title": "我的報告",
      "subtitle": "查看您的化驗及造影報告",
      "error": "無法載入報告，請稍後再試。",
      "referenceRange": "（參考值：{{range}}）",
      "states": {
        "noResults": "暫無報告。"
      }
    },
    "messages": {
      "title": "訊息",
      "subtitle": "與您的醫療團隊聯絡",
      "error": "無法載入訊息，請稍後再試。",
      "fromSender": "來自 {{name}}",
      "labels": {
        "subject": "主旨",
        "message": "訊息內容",
        "reply": "回覆"
      },
      "placeholders": {
        "subject": "訊息主旨",
        "message": "請輸入您的訊息...",
        "reply": "請輸入您的回覆..."
      },
      "actions": {
        "newMessage": "新訊息",
        "back": "返回訊息列表",
        "sendMessage": "發送訊息",
        "sendReply": "發送回覆",
        "sending": "正在發送..."
      },
      "states": {
        "noMessages": "暫無訊息。"
      },
      "thread": {
        "fromSenderWithType": "來自 {{name}}（{{type}}）"
      },
      "compose": {
        "title": "新訊息",
        "subtitle": "您的訊息將發送給您的醫療團隊。"
      },
      "toast": {
        "sent": "訊息已發送",
        "sendFailed": "訊息發送失敗"
      }
    },
    "forms": {
      "title": "表格",
      "subtitle": "填寫所需的表格及問卷",
      "error": "無法載入表格，請稍後再試。",
      "sections": {
        "pending": "待填寫",
        "completed": "已完成"
      },
      "labels": {
        "required": "必填"
      },
      "placeholders": {
        "select": "請選擇……"
      },
      "actions": {
        "fillOut": "填寫",
        "back": "返回表格列表",
        "submit": "提交表格",
        "submitting": "提交中……"
      },
      "states": {
        "noPending": "暫無待填寫的表格。",
        "noCompleted": "暫無已完成的表格。",
        "noFields": "此表格沒有需要填寫的欄位。"
      },
      "toast": {
        "submitted": "表格已成功提交",
        "submitFailed": "表格提交失敗"
      }
    }
  }
}
